import { defineStore } from 'pinia'
import Echo from 'laravel-echo'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    authUser: null,
    authToken: null,
    tokenExpirationDate: null,
    vigencia: null /*SE LLENA EN EL MODAL*/,
    seccionPresupuestal: null /*SE LLENA EN EL MODAL*/,
    planDesarrollo: null /*SE LLENA EN EL MODAL*/,
    permissions: [],
  }),
  getters: {
    user: (state) => state.authUser,
    token: (state) => state.authToken,
    permisos: (state) => state.permissions,
  },
  actions: {
    async login(form) {
      await axios
        .post('/api/v1/auth/login', form)
        .then((res) => {
          this.authToken = res.data.token
          this.authUser = res.data.user
          this.tokenExpirationDate = new Date(Date.now() + res.data.expires_in * 60 * 1000)
          Object.assign(this.permissions, JSON.parse(JSON.stringify(res.data.permissions)))
          // redirect to previous url or default to home page
          this.initializeEcho()
          // this.router.push(this.returnUrl || { name: res.data.homeView });
          this.router.push({ name: res.data.homeView })
          //this.startAutoRefresh(res.data.expires_in); // Inicia el refresco automático suspendido revisar gran client
        })
        .catch((errors) => {
          console.error(errors)
          let desc = ''
          errors.response.data.errors.map((e) => {
            desc = desc + ' ' + e
          })
          this.errors = desc
        })
    },
    async register(form) {
      await this.getToken()
      await axios
        .post('/api/auth/register', form)
        .then((res) => {
          console.log(res.data.messege, 'success')
          setTimeout(() => this.router.push('/login'), 2000)
        })
        .catch((errors) => {
          let desc = ''
          errors.response.data.errors.map((e) => {
            desc = desc + ' ' + e
          })
        })
    },
    async logout() {
      console.log('Logout')
      await axios
        .get('/api/v1/auth/logout', {
          headers: {
            Authorization: 'Bearer ' + this.authToken,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.authToken = null
            this.authUser = null
            this.permissions = []
            this.vigencia = null;
            this.seccionPresupuestal = null;
            this.planDesarrollo = null;

            if (sessionStorage.getItem('anualidad') && JSON.parse(sessionStorage.getItem('anualidad')).id && sessionStorage.getItem('seccionPresupuestal') && sessionStorage.getItem('seccionPresupuestal').id != "") {
              sessionStorage.removeItem("anualidad");
              sessionStorage.removeItem("seccionPresupuestal");
            }

            if (this.echo) {
              this.echo.disconnect()
            }
            this.router.push('/login')
          } else {
            console.error('Unexpected response status: ' + response.status)
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.authToken = null
            this.authUser = null
            this.permissions = []

            if (sessionStorage.getItem('anualidad') && JSON.parse(sessionStorage.getItem('anualidad')).id && sessionStorage.getItem('seccionPresupuestal') && sessionStorage.getItem('seccionPresupuestal').id != "") {
              sessionStorage.removeItem("anualidad");
              sessionStorage.removeItem("seccionPresupuestal");
            }

            if (this.echo) {
              this.echo.disconnect()
            }

            this.router.push('/login')
          } else {
            console.error('An unexpected error occurred during logout')
          }
        })
    },
    async checkAuth() {
      await axios
        .get('/api/v1/auth/profile', {
          headers: {
            Authorization: 'Bearer ' + this.authToken,
          },
        })
        .then((res) => { })
        .catch((errors) => {
          const status = errors.response.status
          if (status === 401) {
            console.log('Profile LogOut')
            this.authToken = null
            this.authUser = null
          }
        })
    },
    async refreshToken() {
      try {
        console.log('ir a refrescar')
        const response = await axios.post('/api/v1/auth/refreh-token', {
          user_id: this.authUser.id,
        })
        this.authToken = response.data.token
        this.tokenExpirationDate = new Date(Date.now() + response.data.expires_in * 60 * 1000) // Usa la duración de expiración devuelta
        localStorage.setItem('token', this.authToken)
      } catch (error) {
        console.error('Error refreshing token:', error)
      }
    },
    startAutoRefresh(timeExpire) {
      setInterval(
        async () => {
          if (!this.tokenExpirationDate || !this.authToken) return
          const timeRemaining = this.tokenExpirationDate - new Date()
          // Define el umbral para refrescar el token (5 minutos antes de que expire)
          const expirationTime = timeExpire * 60 * 1000
          // Si el tiempo restante es menor que el umbral, refresca el token
          if (timeRemaining > 0 && timeRemaining < expirationTime) {
            await this.refreshToken()
          }
        },
        timeExpire * 60 * 1000,
      ) // Verifica cada minuto
    },

    initializeEcho() {
      if (!this.token) return
      this.echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_PUSHER_APP_KEY,
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
        authEndpoint: `${import.meta.env.VITE_API_URL}/api/broadcasting/auth`,
        encrypted: false,
        wsPort: 80,
        wssPort: 443,
        wsHost: import.meta.env.VITE_PUSHER_HOST,
        enabledTransports: ['ws', 'wss'],
        auth: {
          headers: {
            Authorization: `Bearer ${this.token}`,
            Accept: 'application/json',
          },
        },
      })

      if (this.echo) {
        window.Echo = this.echo
      } else {
        console.error('Error al inicializar Laravel Echo')
      }
    },
  },
  persist: true,
})
